(function () {
    'use strict';

    angular
        .module('app')
        .controller('WinbackStateOffersEditController', WinbackStateOffersEditController);

    WinbackStateOffersEditController.$inject = ['debug', '$stateParams', 'i18n', 'API', 'helpers',];

    function WinbackStateOffersEditController(debug, $stateParams, i18n, API, helpers) {
        var vm = this;
        vm.id = $stateParams.id;
        vm.isSaving = false;
        vm.save = save;
        vm.stateOffer = {};
        vm.winbackOffers = [];
        vm.loadingState = {
            stateOffer: false,
            winbackOffers: false,
        };
        vm.now = helpers.getDatabaseDatetime();

        activate();

        function activate() {
            loadStateOffer();
            loadWinbackOffers();
        }

        function loadStateOffer() {
            vm.loadingState.stateOffer = true;
            API.WinbackStateOffer.get({ id: vm.id, }).$promise.then(function (response) {
                angular.extend(vm.stateOffer, response);

                vm.loadingState.stateOffer = false;
            }, function (response) {
                debug.log(response);
            });
        }

        function loadWinbackOffers() {
            vm.loadingState.winbackOffers = true;
            var promise = API.WinbackOffer.get().$promise;

            promise.then(function (response) {
                if (response.items.length) {
                    vm.winbackOffers = [];
                    angular.forEach(response.items, function (game) {
                        vm.winbackOffers.push({
                            name: game.name,
                            label: game.name,
                            value: game.id
                        });
                    });
                }
            }, function (response) {
                debug.log(response);
            })
                .finally(function () {
                    vm.loadingState.winbackOffers = false;
                });
        }

        function save() {
            if (vm.isSaving) {
                return;
            }

            vm.isSaving = true;

            var stateOffer = angular.copy(vm.stateOffer);

            API.WinbackStateOffer.save({}, stateOffer).$promise.then(function (response) {
                if (response.id) {
                    angular.extend(vm.stateOffer, response);
                    window.toast({ message: i18n.get('SAVED'), autoRemoveTime: 5000, type: 'success' });
                    loadStateOffer();
                }
            }, function () {
            })
                .finally(function () {
                    vm.isSaving = false;
                });
        }
    }
})();